import { useCallback } from "react";

import { AppNotification, Notification } from "@common/models/notifications";
import { useUnreadNotificationsContext } from "@main/context/App/UnreadNotificationsContext";

import { useAppDeps } from "../App.dependencies";

export default function useNotificationsApiConsumer() {
  const { unreadNotifications, setUnreadNotifications } = useUnreadNotificationsContext();

  const { notificationsService } = useAppDeps();

  const fetchUnreadNotificationsAndDispatch = useCallback(
    async (workspaceId: string, signal?: AbortSignal) => {
      const { data } = await notificationsService.getUnreadNotifications(workspaceId, signal);
      if (signal && signal.aborted) return {};

      const adaptedNotificationRecord = constructAppNotifications(data);

      setUnreadNotifications(adaptedNotificationRecord);

      return adaptedNotificationRecord;
    },
    [notificationsService, setUnreadNotifications],
  );

  const constructAppNotifications = (serverNotifications: Notification[]): Record<string, AppNotification[]> => {
    const mapToNotifications = serverNotifications.map((serverNotif) => {
      return {
        app_id: serverNotif.app_id,
        app_notifications: serverNotif.app_notifications,
      };
    });

    return mapToNotifications.reduce((acc, curr) => {
      const { app_id, app_notifications } = curr;
      return { ...acc, [app_id]: app_notifications };
    }, {} as Record<string, AppNotification[]>);
  };

  return {
    unreadNotifications,
    fetchUnreadNotificationsAndDispatch,
  };
}
